import axios from 'axios';
import { findIndex } from 'lodash';
import { notification } from 'antd';
let requests = [];

const clearRequestArray = () => {
  requests = [];
};

export default clearRequestArray;

export const pendingRequestInterceptors = [
  (req) => {
    const { url } = req;
    const method = req.method.toUpperCase();
    const urlToCheck = url.toString();

    // HANDLING PREVIOUS REQUEST AND CANCELLING IF STILL PANDING
    const index = findIndex(requests, (request) => request.url == url && request.method == method);
    if (index != '-1' && method == 'GET' &&
      !urlToCheck.includes('/api/v2/seller_skus/vendors') &&
      !(urlToCheck.includes('s3')) &&
      !(urlToCheck.includes('presigned_url'))
    ) {
      const { cancel } = requests[index];
      requests.splice(index, 1);
      cancel('Pending Request cancel due to new request');
    }

    // HANDLING CURRENT REQUEST AND CREATING CANCEL TOKEN
    if (method == 'GET' && !urlToCheck.includes('/api/v2/seller_skus/vendors') && !(urlToCheck.includes('s3')) && !(urlToCheck.includes('presigned_url'))) {
      req.cancelToken = new axios.CancelToken((cancel) => {
        requests.push({
          url,
          method,
          cancel
        });
      });
    }

    if (urlToCheck.includes('/api/v2/users/logged_in_user')) req.signal = null;

    return req;
  },
  (error) => {
    return Promise.reject(error);
  }
];

export const pendingRsponseInterceptors = [
  (res) => {
    const { config } = res;
    const { url } = config;
    const method = config.method.toUpperCase();

    // REMOVING REQUEST FROM ARRAY AFTER GETTING RESPONSE
    const index = findIndex(requests, (req) => req.url == url && req.method == method);
    if (index != '-1') requests.splice(index, 1);
    return res;
  },
  (error) => {

    // Skip 401 handling for specific routes
    const skip401HandlingRoutes = ['/auth/sign-in', '/auth/send-verification-mail', '/payment/user-billing-history'];
    const requestUrl = error.config?.url || '';

    if (error.response?.status === 403 ) {
      if (error.response.data?.message === 'Permission denied'){
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        }
        else{
        setTimeout(() => {
          window.location.href = '/';
        }, 1000);
      }

      return Promise.resolve();
    }
    if (error.response?.status === 401 && !skip401HandlingRoutes.some(route => requestUrl.includes(route))) {
      // Show session expired notification
      notification.error({
        message: 'Session Expired',
        description: 'Please sign in again.',
        placement: 'topRight',
        duration: 3
      });
      
      // Clear any existing tokens or user data from storage
      localStorage.clear();
      sessionStorage.clear();
      
      // Clear the pending requests
      requests = [];
      
      // Redirect to sign-in page after a short delay for the toast to be visible
      setTimeout(() => {
        window.location.href = '/auth/sign-in';
      }, 1000);
      
      return Promise.resolve(); // Prevent further error handling
    }
    
    return Promise.reject(error);
  }
];
